import React from 'react';
import './SelfAssessmentHeader.scss';

const SelfAssessmentHeader = () => {
  return (
    <header className="self-assessment-header">
      <div className="header-brand">OTOS</div>
    </header>
  );
};


export default SelfAssessmentHeader;
